import React, { useState, useEffect } from 'react'
import Modal from './components/Modal'
import './style.css'


const Pages = ({ history, dispatch, searchArgs }) => {
    const [isBlinkComponentsActivated, setIsBlinkComponentsActivated] = useState(true)
    const [visible, setVisible] = useState(false) //对话框是否可见
    const [title, setTitle] = useState("参数设置")
    useEffect(() => {
        BimfaceSDKLoader.load(loaderConfig, successCallback, failureCallback);
        return () => {
            console.log('卸载viewtoken')
            viewer3D.removeView('e349806331e647b09615a97013d4b999')
        }
    }, [])
    const showBox = (type) => {
        setVisible(true)  //设置对话框可见
    }
    const cancel = () => {
        setVisible(false)
    }
    var viewToken = 'e349806331e647b09615a97013d4b999';
    var viewer3D;
    var app;
    var loaderConfig = new BimfaceSDKLoaderConfig();
    loaderConfig.viewToken = viewToken;
    // 加载成功回调函数
    const successCallback = (viewMetaData) => {
        var dom4Show = document.getElementById('domId');
        // 设置WebApplication3D的配置项
        var webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
        webAppConfig.domElement = dom4Show;
        // 创建WebApplication3D，用以显示模型
        app = new Glodon.Bimface.Application.WebApplication3D(webAppConfig);
        app.addView(viewToken);
        viewer3D = app.getViewer();
        viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.MouseClicked, getData);
        viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded, function () {
            blink()
        })
    }

    const  getData = (data) => {
        //获取构件属性
        if (data.objectId == "2074029486754112.1787048") {
            showBox()
        }
    }
    // 加载失败回调函数
    const failureCallback = (error)=> {
        console.log(error);
    }
    const blink = ()=>{
        if (isBlinkComponentsActivated) {
            // 构件闪烁             
            viewer3D.setBlinkComponentsById(["2074029486754112.1787048"]);
            viewer3D.setBlinkColor(new Glodon.Web.Graphics.Color("#32D3A6", 0.8));
            viewer3D.enableBlinkComponents(true);
            viewer3D.setBlinkIntervalTime(500);
            viewer3D.render();
        }
    }

    return (
        <div className='bim'>
            <div id="domId"></div>
            {
                visible &&
                <Modal title={title} visible={visible} onCancel={() => cancel()}>
                    <div className='bimModalContent'>
                        <div className ='title'>格栅机测试</div>
                        <div className = 'solid'></div>
                        <div className='bimModalup'>
                            <div className='item_1'>开关</div>
                            <div className='item_2'>
                                <span className='item_3'>关</span>
                                <span className='item_3'>开</span>
                            </div>
                        </div>
                        <div className='bimModalcenter'>
                            <div className='item_1'>控制模式</div>
                            <div className='item_2'>
                                <span className='item_3'>手动</span>
                                <span className='item_3'>自动</span>
                            </div>
                        </div>
                        <div className='bimModaldown'>
                            <div className='bimModaldownContent'>
                                <div className='content'><div className='light gray'></div><div className='font'>运行</div></div>
                                <div className='content'><div className='light yellow'></div><div className='font'>停止</div></div>
                            </div>
                            <div className='bimModaldownContent'>
                                <div className='content'><div className='light green'></div><div className='font'>正常</div></div>
                                <div className='content'><div className='light gray'></div><div className='font'>故障</div></div>
                            </div>
                            <div className='bimModaldownContent'>
                                <div className='content'><div className='light green'></div><div className='font'>手动</div></div>
                                <div className='content'><div className='light gray'></div><div className='font'>自动</div></div>
                            </div>
                        </div>
                    </div>
                </Modal>
            }
        </div>
    )
}

export default Pages